import React from "react"
import PropTypes from 'prop-types'
import resolveProps from '../../utils/resolveProps'
import clearProps from '../../utils/clearProps'

export default class Subtitle extends React.Component {
  constructor(props) {
    super(props)

    this.config = { 
      types : [
        'inverse'
      ],
      modifiers : [
        {
          title: 'sm',
          isDefault: true,
        }, 
        'md'
      ],
      states : []
    }

  }
  
  render() {

    const { children, tag, ...rest } = this.props;
    let CustomTag = tag || 'p';
    const props = clearProps(this.props)
    
    return <CustomTag {...rest} className={resolveProps(this.props, this.config,'Subtitle')}>
        {children}
    </CustomTag>
  }
}

Subtitle.propTypes = {
  inverse : PropTypes.bool,
  children: PropTypes.node,
}